<template>
  <PreviewFrame :accent="slide.accent">
    <template #presenter>
      <div class="cf-header">
        <span class="cf-bar cf-bar--xl"></span>
        <span class="cf-bar cf-bar--md"></span>
      </div>
      <div class="cf-stack">
        <article
          v-for="(card, i) in cards"
          :key="i"
          class="cf-card"
          :style="{ '--i': i }"
        >
          <header class="cf-card-meta">
            <span class="material-symbols-rounded cf-lock">lock</span>
            <span class="cf-card-anon">Anonymous</span>
          </header>
          <span class="cf-bar cf-bar--lg"></span>
          <span class="cf-bar" :style="{ width: card.w }"></span>
        </article>
      </div>
    </template>

    <template #audience>
      <div class="cf-phone-anon">
        <span class="material-symbols-rounded cf-phone-lock">lock</span>
        Anonymous
      </div>
      <span class="cf-phone-q"></span>
      <div class="cf-phone-input">
        <span class="cf-bar cf-bar--md"></span>
        <span class="cf-bar cf-bar--sm"></span>
        <span class="cf-caret"></span>
      </div>
      <button type="button" class="cf-phone-submit" tabindex="-1">
        Send
      </button>
    </template>
  </PreviewFrame>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue'
import type { SlideType } from '../../data/slideTypeCatalog'
import PreviewFrame from './PreviewFrame.vue'

export default Vue.extend({
  name: 'PreviewConfessions',
  components: { PreviewFrame },
  props: { slide: { type: Object as PropType<SlideType>, required: true } },
  data() {
    return {
      cards: [
        { w: '60%' },
        { w: '45%' },
        { w: '70%' },
      ],
    }
  },
})
</script>

<style scoped lang="scss">
.cf-bar {
  display: block; height: 7px; border-radius: 999px;
  background: rgba(15, 15, 20, 0.1);
}
.cf-bar--xl { width: 70%; background: rgba(15, 15, 20, 0.2); height: 8px; }
.cf-bar--lg { width: 80%; }
.cf-bar--md { width: 50%; }
.cf-bar--sm { width: 30%; }

.cf-header {
  display: flex; flex-direction: column; gap: 6px;
  padding-bottom: 8px;
  border-bottom: 1px dashed color-mix(in srgb, var(--accent) 20%, transparent);
}

.cf-stack {
  display: grid; gap: 8px;
}
.cf-card {
  background: color-mix(in srgb, var(--accent) 6%, white);
  border: 1px solid color-mix(in srgb, var(--accent) 20%, transparent);
  border-radius: 10px;
  padding: 9px 11px;
  display: flex; flex-direction: column; gap: 6px;
  animation: cf-stack-in 4s ease-out infinite;
  animation-delay: calc(var(--i) * 800ms);
  opacity: 0;
}
.cf-card-meta {
  display: flex; align-items: center; gap: 5px;
  font-size: 9px; font-weight: 700;
  color: var(--accent);
  text-transform: uppercase;
  letter-spacing: 0.06em;
}
.cf-lock { font-size: 12px; }
.cf-card-anon { letter-spacing: 0.04em; }

/* phone */
.cf-phone-anon {
  display: flex; align-items: center; gap: 5px;
  padding: 5px 9px;
  border-radius: 999px;
  background: color-mix(in srgb, var(--accent) 12%, white);
  color: var(--accent);
  font-size: 10px;
  font-weight: 700;
  width: max-content;
  margin-bottom: 2px;
}
.cf-phone-lock { font-size: 12px; }
.cf-phone-q {
  display: block; height: 8px; width: 70%;
  border-radius: 999px;
  background: rgba(15, 15, 20, 0.18);
}
.cf-phone-input {
  position: relative;
  min-height: 60px;
  border-radius: 6px;
  border: 1px solid rgba(15, 15, 20, 0.15);
  padding: 8px;
  display: flex; flex-direction: column; gap: 4px;
}
.cf-caret {
  position: absolute;
  bottom: 8px; left: 8px;
  width: 1px; height: 12px;
  background: var(--accent);
  animation: cf-caret 1s steps(2) infinite;
}
.cf-phone-submit {
  appearance: none;
  padding: 7px 10px;
  border-radius: 6px;
  background: var(--accent);
  color: white;
  border: none;
  font-family: inherit;
  font-size: 11px;
  font-weight: 700;
  cursor: pointer;
}

@keyframes cf-stack-in {
  0%, 10%   { opacity: 0; transform: translateY(8px) scale(0.98); }
  25%, 90%  { opacity: 1; transform: translateY(0) scale(1); }
  100%      { opacity: 1; transform: translateY(0) scale(1); }
}
@keyframes cf-caret {
  0% { opacity: 1; }
  50% { opacity: 0; }
}

@media (prefers-reduced-motion: reduce) {
  .cf-card { animation: none; opacity: 1; }
  .cf-caret { animation: none; }
}
</style>
